import * as icons from 'react-bootstrap-icons';

// https://icons.getbootstrap.com/

export default function Icon({name, size, ...props}) {
    size = size || 14;
    
    const BootstrapIcon = icons[name];
    return (<BootstrapIcon size={size} {...props} />);
}